export { default as DetailsModal } from './DetailsModal';
